/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Field } from '../../models/field';
import { FieldApiRespModel } from '../../models/field-api-resp-model';

export interface ApiMasterFieldAddPost$Params {
      body?: Field
}

export function apiMasterFieldAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterFieldAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FieldApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterFieldAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FieldApiRespModel>;
    })
  );
}

apiMasterFieldAddPost.PATH = '/api/Master/Field/Add';
